// const series1 = require('./series/_state-series1')
// const series2 = require('./series/_state-series2')
// const series3 = require('./series/_state-series3')
// const series4 = require('./series/_state-series4')

// use Require() to require file in runtime, instead require()

// const series1 = _require('_state-series1')
// const series2 = _require('_state-series2')
// const series3 = _require('_state-series3')
// const series4 = _require('_state-series4')

// let loadSerieses = () => {
//   let files = [
//     '_state-series1.json'
//   ]

//   let _serieses = []
//   let _promises = []

//   files.forEach(file => {
//     // getSeries(`@/series-data/${file}`)
//     //   .then(json => {
//     //     _serieses.push(json)
//     //   })

//     console.log('### debug import ###')
//     console.log(import(file))

//     _promises.push(import(file))
//       // .then(({default: jsonInfo}) => {
//       //   _serieses.push(jsonInfo)
//       // })

//     Promise.all(_promises, values => {

//     })
//   })

//   return _serieses
// }

export let state = (() => {

  return {
    token: null,

    // requestSeriesesJson: false,

    // requestSeriesesJsonTimeout: 10000, // in ms

    // requestSeriesesJsonExpire: true,

    //alertShowed: getValueFromSessionStorage('alert-showed'), // 首頁公告訊息是否已經顯示過
    // serieses: [
    //   series1, series2, series3, series4
    // ]

    // serieses: require('@/series-data/index.js')(),

    //serieses: loadSerieses(),

    // serieses: [
    //   require('@/series-data/_state-series1.json'),
    //   require('@/series-data/_state-series2.json'),
    //   require('@/series-data/_state-series3.json'),
    //   require('@/series-data/_state-series4.json'),
    //   require('@/series-data/_state-series5.json'),
    // ],

    seriesesFilesLoading: false,

    seriesesFiles: [],

    seriesesInState: [],

    // lazy-load version
    // serieses: loadSerieses(),

    // serieses: [
    //   require.context('_state-series1.json'),
    //   require.context('_state-series2.json'),
    //   require.context('_state-series3.json'),
    //   require.context('_state-series4.json'),
    //   require.context('_state-series5.json'),
    // ],

    currentCourse: null,
  }
})()

// let state = {
//   token: null,
//   serieses: getSerieses,
// }

// module.exports = state



// WEBPACK FOOTER //
// ./src/vuex/state.js